<canvas
  id="canvas"
  class="signature drawer"
  (mousedown)="drawSignature()"
  (mousemove)="traceSignatureMouse($event)"
  (mouseup)="redibujarTrazado()"
  (touchstart)="drawSignature()"
  (touchmove)="traceSignatureTouch($event)"
  (touchend)="redibujarTrazado()"
></canvas>
<div class="clean-drawer">
  <span (click)="cleanSignature()" class="title-font" *ngIf="clean">
    {{ 'REPORTS.FILTER.CLEAR' | translate }}
  </span>
</div>
<div *ngIf="isAutoSignatureEnabled"  class="automatic-signature-button-container">
  <button nz-button nz-dropdown [nzDropdownMenu]="menu" (click)="false">
    {{ 'FORM.SIGNATURE.AUTOMATIC_SIGN' | translate }}
    <nz-icon nzType="down"></nz-icon>
  </button>
  <nz-dropdown-menu #menu="nzDropdownMenu">
    <ul nz-menu>
      <li nz-menu-item (click)="automaticSignature(1)">
        <a>{{ textToSign }}</a>
      </li>
      <li nz-menu-item (click)="automaticSignature(2)">
        <a>{{ textToSign }}</a>
      </li>
      <li nz-menu-item (click)="automaticSignature(3)">
        <a>{{ textToSign }}</a>
      </li>
    </ul>
  </nz-dropdown-menu>
</div>

